import '../../styles/buttons.css';

interface LoadMoreButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  loadingText?: string;
  buttonText?: string;
  /**
   * 'primary' (既定): ゴールド半透明 (btn-modal)。ページ内の主要な追加読み込み用。
   * 'secondary': 白半透明 (btn-modal-secondary)。モーダル内の補助操作など、
   * 目立たせたくない文脈で使う (例: PromptHistoryModal)。
   */
  variant?: 'primary' | 'secondary';
}

export function LoadMoreButton({
  onClick,
  isLoading = false,
  loadingText = '読み込み中...',
  buttonText = 'さらに読み込む',
  variant = 'primary',
}: LoadMoreButtonProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
      <div style={{ width: '70%', height: '36px' }}>
        <button
          type="button"
          className={variant === 'secondary' ? 'btn-modal-secondary' : 'btn-modal'}
          style={{ width: '100%', height: '100%', border: '0' }}
          onClick={onClick}
          disabled={isLoading}
        >
          {isLoading ? loadingText : buttonText}
        </button>
      </div>
    </div>
  );
}
